export default __webpack_public_path__ + "static/media/officeboy.e741a3da.jpg";